import PropTypes from 'prop-types';
import { AlertTriangle } from 'lucide-react';

const ScopeErrorBanner = ({ subcontractorResults, onViewDetails }) => {
  // Count failed analyses
  const failedSubcontractors = Object.entries(subcontractorResults)
    .filter(([, result]) => result.error)
    .map(([name]) => name);

  if (failedSubcontractors.length === 0) {
    return null;
  }

  const totalSubcontractors = Object.keys(subcontractorResults).length;
  const successfulCount = totalSubcontractors - failedSubcontractors.length;

  return (
    <div className="scope-error-banner">
      <div className="banner-content">
        <AlertTriangle className="warning-icon" />
        <div className="banner-text">
          <strong>
            Analysis failed for {failedSubcontractors.length} of{' '}
            {totalSubcontractors} subcontractors
          </strong>
          <div className="failed-list">
            Failed: {failedSubcontractors.join(', ')}
            {successfulCount > 0 && (
              <span className="success-note">
                ({successfulCount} completed successfully)
              </span>
            )}
          </div>
        </div>
        <button onClick={onViewDetails} className="view-details-button">
          View Details
        </button>
      </div>
    </div>
  );
};

ScopeErrorBanner.propTypes = {
  subcontractorResults: PropTypes.object.isRequired,
  onViewDetails: PropTypes.func.isRequired,
};

export default ScopeErrorBanner;
